export const modalPropsUpdate = (detailsError, prevProps, scorecardCreateSuccess, scorecardCreateError, sectionTemplateSuccess, sectionTemplateError) => {
    if (detailsError !== prevProps.detailsError ||
        scorecardCreateSuccess !== prevProps.scorecardCreateSuccess ||
        scorecardCreateError !== prevProps.scorecardCreateError
        || sectionTemplateSuccess !== prevProps.sectionTemplateSuccess ||
        sectionTemplateError !== prevProps.sectionTemplateError) {
        return true;
    } else {
        return false;
    }
}
export const modalStatus = (detailsError, scorecardCreateError, searchFailure, sectionTemplateError) => {
    const detailsErrorFlag = checkDetailsError(detailsError);
    const createErrorFlag = checkCreateError(scorecardCreateError);
    const searchFail = checkSearchFailure(searchFailure);
    const sectionTemplateFlag = checkSectionTemplateFailure(sectionTemplateError);
    if (detailsErrorFlag && createErrorFlag && searchFail && sectionTemplateFlag) {
        return true;
    } else {
        return false;
    }
}
const checkSectionTemplateFailure = (sectionTemplateError) => {
    let sectionTemplateFlag = false;
    if (sectionTemplateError) {
        if(sectionTemplateError.status === 401) {
            sectionTemplateFlag = true
        } else {
            sectionTemplateFlag = false
        }
    } else {
        sectionTemplateFlag = false
    }
    return sectionTemplateFlag;
}
const checkCreateError = (scorecardCreateError) => {
    let createFlag = false;
    if (scorecardCreateError) {
        if (scorecardCreateError.status === 401) {
            createFlag = true
        } else {
            createFlag = false
        }

    } else {
        createFlag = false
    }
    return createFlag;
}

const checkDetailsError = (detailsError) => {
    let detailsFlag = false;
    if (detailsError) {
        if (detailsError.status === 401) {
            detailsFlag = true
        } else {
            detailsFlag = false
        }

    } else {
        detailsFlag = false
    }
    return detailsFlag;
}

const checkSearchFailure = (searchFailure) => {
    let searchFlag = false;
    if (searchFailure) {
        if (searchFailure.status === 401) {
            searchFlag = true
        } else {
            searchFlag = false
        }

    } else {
        searchFlag = false
    }
    return searchFlag;
}

export const scorecardModals = (props, state) => {
    let scorecardModalData;
    if (props.scorecardCreateSuccess.data.status === 200) {
        scorecardModalData = {
            saveSuccess: !state.saveSuccess,
            scorecardAction: 'Edited'
        }
    } else if (props.scorecardCreateSuccess.data.status === 201) {
        scorecardModalData = {
            saveSuccess: !state.saveSuccess,
            scorecardAction: 'Created'
        }
        // this.props.setScorecardId(this.props.scorecardCreateSuccess.data.data.id);
    }
    return scorecardModalData;
}
export const sectionTemplateModal = (props, state) => {
    let sectionTemplatedModalData;
    if (props.sectionTemplateSuccess.status === 200) {
        sectionTemplatedModalData = {
            saveSuccess: !state.saveSuccess,
            sectionTemplateAction: 'Edited'
        }
    } else if (props.sectionTemplateSuccess.status === 201) {
        sectionTemplatedModalData = {
            saveSuccess: !state.saveSuccess,
            sectionTemplateAction: 'Created'
        }
    }
    return sectionTemplatedModalData;
}
